export const STEP_WAITING = 0;
export const STEP_IN_PROGRESS = 1;
export const STEP_OK = 2;
export const STEP_NOT_COMPLETE = 3;
export const STEP_NOT_DETECTED = 4;

export const LUBRICATION_TEXTS = {
  [STEP_WAITING]: 'En attente',
  [STEP_IN_PROGRESS]: 'En cours',
  [STEP_OK]: 'Correctement réalisée',
  [STEP_NOT_COMPLETE]: 'Incomplète',
  [STEP_NOT_DETECTED]: 'Non réalisée',
  [undefined]: 'En attente',
  [null]: 'Aucune donnée',
};

export const PIPES_TEXTS = {
  [STEP_WAITING]: 'En attente d\'emmanchement',
  [STEP_IN_PROGRESS]: 'Emmanchement en cours',
  [STEP_OK]: 'Emmanchement correctement réalisé',
  [STEP_NOT_COMPLETE]: 'Emmanchement incomplet',
  [STEP_NOT_DETECTED]: 'Pas d\'emmanchement réalisé',
  [undefined]: 'En attente d\'emmanchement',
  [null]: 'Aucune donnée d\'emmanchement',
};

export const CLIPS_TEXTS = {
  [STEP_WAITING]: 'En attente de clipsage',
  [STEP_IN_PROGRESS]: 'Clipsage en cours',
  [STEP_OK]: 'Clipsage correctement réalisé',
  [STEP_NOT_COMPLETE]: 'Clipsage incomplet',
  [STEP_NOT_DETECTED]: 'Pas de clipsage réalisé',
  [undefined]: 'En attente de clipsage',
  [null]: 'Aucune donnée de clipsage',
};

export const STEP_COLORS = {
  [STEP_WAITING]: 'bg-perception-gray-800',
  [STEP_IN_PROGRESS]: 'bg-perception-gray-800',
  [STEP_OK]: 'bg-green-500',
  [STEP_NOT_COMPLETE]: 'bg-orange-500',
  [STEP_NOT_DETECTED]: 'bg-red-500',
  [undefined]: 'bg-perception-gray-800',
  [null]: 'bg-perception-gray-800',
};

export const PHASES_TEXTS = {
  0: 'Arrêt',
  1: 'Lubrification',
  2: 'En cours d\'analyse',
};

export const PHASES_COLORS = {
  0: 'bg-gray-500',
  1: 'bg-green-500',
  2: 'bg-perception-blue',
  error: 'bg-yellow-500'
}